import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '~/components/composites/confirm-dialog'
import { useMutation } from '~/hooks/use-mutation'
import { useQueryClientHelper } from '~/hooks/use-query-client'
import { useToast } from '~/hooks/use-toast'
import { useAppStore } from '~/stores/app'
import { DialogId } from '~/types/common'
import { MutationKey } from '~/types/mutation-key'
import { QueryKey } from '~/types/query-key'
import type { Skill } from '~/types/skill'

type SkillDeleteDialogProps = {
  deletingItem?: Skill | null
}

export function SkillDeleteDialog({ deletingItem }: SkillDeleteDialogProps) {
  const { t } = useTranslation()
  const { showSuccess } = useToast()
  const { invalidateQueries } = useQueryClientHelper()
  const closeDialog = useAppStore((state) => state.closeDialog)

  const { mutate: deleteSkill, isPending } = useMutation({
    mutationKey: MutationKey.DELETE_SKILL,
    method: 'DELETE',
    idParams: deletingItem ? { id: deletingItem.id } : undefined,
    options: {
      onSuccess: () => {
        showSuccess(t('common.delete'))
        invalidateQueries(QueryKey.SKILLS)
        closeDialog(DialogId.DELETE_SKILL)
      },
    },
  })

  const handleConfirm = () => {
    deleteSkill({})
  }

  return (
    <ConfirmDialog
      dialogId={DialogId.DELETE_SKILL}
      title={t('common.delete')}
      description={t('skills.deleteConfirm')}
      onConfirm={handleConfirm}
      destructive
      loading={isPending}
    />
  )
}
